export const SOURCE: Record<string, string> = { faceit: "FACEIT", valve: "Matchmaking", upload: "Загрузка" };

export const CATEGORY: Record<string, string> = {
  faceit: "FACEIT",
  premier: "Premier",
  competitive: "Соревновательный",
  wingman: "Напарники",
  matchmaking: "Матчмейкинг",
  community: "Другие серверы",
};

/** Category name; community matches show the server's brand ("XPLAY.GG"). */
export function categoryLabel(category: string | null | undefined, serverName?: string | null) {
  if (category === "community" && serverName) {
    const brand = serverName.split(/[•|\-–—]/)[0].trim();
    if (brand && brand.length <= 24) return brand;
  }
  return CATEGORY[category ?? ""] ?? "—";
}
export const KIND: Record<string, string> = { kills: "Все фраги", highlights: "Хайлайты", mistakes: "Ошибки" };

export const mapName = (map: string | null | undefined) =>
  map ? map.replace(/^de_/, "").replace(/^\w/, (c) => c.toUpperCase()) : "—";

// The year only when it is not this one: "5 окт.", "28 дек. 2025 г.".
const year = (d: Date) => (d.getFullYear() === new Date().getFullYear() ? {} : { year: "numeric" as const });

export const date = (ts: number | null | undefined) => {
  if (!ts) return "—";
  const d = new Date(ts * 1000);
  return d.toLocaleDateString("ru-RU", { day: "numeric", month: "short", ...year(d) });
};

export const dateTime = (ts: number | null | undefined) => {
  if (!ts) return "—";
  const d = new Date(ts * 1000);
  return d.toLocaleString("ru-RU", { day: "numeric", month: "short", ...year(d), hour: "2-digit", minute: "2-digit" });
};

export const ago = (ts: number | null | undefined) => {
  if (!ts) return "никогда";
  const s = Math.floor(Date.now() / 1000) - ts;
  if (s < 90) return `${s} с назад`;
  if (s < 5400) return `${Math.round(s / 60)} мин назад`;
  if (s < 172800) return `${Math.round(s / 3600)} ч назад`;
  return dateTime(ts);
};

export const pct = (a: number, b: number) => (b ? `${Math.round((100 * a) / b)}%` : "—");
export const bytes = (n: number | null | undefined) =>
  !n ? "—" : n < 100 * 1024 ? `${Math.max(1, Math.round(n / 1024))} КБ` : `${(n / 1024 / 1024).toFixed(n > 100 * 1024 * 1024 ? 0 : 1)} МБ`;

/** Russian plural: plural(5, ["матч", "матча", "матчей"]). */
export function plural(n: number, [one, few, many]: [string, string, string]) {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}

/**
 * Recorder errors in plain Russian. The agent writes them in English (they
 * also go to logs); these are the ones a user can act on.
 */
export function videoError(error: string | null | undefined): string | null {
  if (!error) return null;
  const known: [RegExp, string][] = [
    [/cannot play a demo this old/i, "Демка старее, чем установленная CS2 — игра её не открывает, видео недоступно"],
    [/HLAE does not support this CS2 build|hooks neither/i, "Ждём обновления HLAE под новую версию CS2 — видео запишется само"],
    [/the demo is not published yet/i, "Ждём, пока Valve выложит демку"],
    [/the demo file for this match has expired/i, "Файл демки уже удалён, записывать нечего"],
    [/CS2 is already running/i, "На компьютере запущена CS2 — закройте игру, запись пойдёт сама"],
    [/the account is playing CS2 elsewhere/i, "Аккаунт играет в CS2 в другом месте"],
    [/did not start playing the demo/i, "CS2 не открыла демку вовремя"],
  ];
  for (const [re, text] of known) if (re.test(error)) return text;
  return error;
}
